module.exports = __webpack_public_path__ + "static/media/photo31.8f941515.jpg";